import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import { Button, FormControl, MenuItem, Select, Stack } from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom'
	
const EditModal = ({ data, handleRefresh, category }) => {
  const uploadImage = useUploadImage()
  console.log(data, "datadata")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [svgIcon, setSvgIcon] = useState(null);
const {page_id}= useParams()
  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
};

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    let image_response = null;
    if (selectedFile) {
      image_response = await uploadImage({
          file: selectedFile,
          desiredPath: `app/logo/image`,
      });
  }

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      rank: e.target.rank.value,
      points: e.target.points.value,
      // category: e.target.category.value,
      
      category: page_id,
      priority: e.target.priority.value,
      image: image_response?.response.data || data?.image || "",
    };

    console.log(payload, "payload");

    const { response } = await AppService.award_ranking.update({
      query: `id=${data._id}`,
      payload,
  });

    if (response) {
      setProcessing(false);
      // closeAddProduct();
      setOpenEditProduct(false);

      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Ranking
            </MDTypography>

                     <MDBox mb={2}>
                          <MDTypography variant="button">Name</MDTypography>
                          <MDInput label="Name" name="name" defaultValue={data.name} fullWidth required />
                        </MDBox>

                        <MDBox mb={2}>
                                      <MDTypography variant="button">priority</MDTypography>
                                      <MDInput label="priority" name="priority" defaultValue={data.priority} fullWidth required />
                                    </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="category"
                fullWidth
                required
                defaultValue={data.category._id}
                SelectProps={{ native: true }}
              >
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Rank</MDTypography>
              <FormControl fullWidth>
                <Select name="rank" defaultValue={data.rank}>
                  <MenuItem value="agency">Agency</MenuItem>
                  <MenuItem value="location">Location</MenuItem>
                  <MenuItem value="user">User</MenuItem>
                </Select>
              </FormControl>
            </MDBox>





            <MDBox mb={2}>
              <MDTypography variant="button">Point Required</MDTypography>
              <MDInput label="Point Required" name="points" defaultValue={data.points} fullWidth required />
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" onChange={handleFileChange}/>
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
